import _defineProperty from "@babel/runtime/helpers/defineProperty";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import classNames from 'classnames';
import React from 'react';
var css = {
  "carouselCardItemLoader": "oalp-bnJKQ",
  "withoutVasStrip": "oalp-1Pz34",
  "imageShimmer": "oalp-3ovD_",
  "detailsContainer": "oalp-vhynZ",
  "priceShimmer": "oalp-1ShN8",
  "emiShimmer": "oalp-2ii-4",
  "titleShimmer": "oalp-9FYND",
  "detailsShimmer": "oalp-3Fqj3",
  "stripShimmer": "oalp-96_dV"
};
export var ShimmerCarouselCard = function ShimmerCarouselCard(_ref) {
  var _ref$showVasStrip = _ref.showVasStrip,
    showVasStrip = _ref$showVasStrip === void 0 ? true : _ref$showVasStrip;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.carouselCardItemLoader, _defineProperty({}, css.withoutVasStrip, !showVasStrip))
  }, /*#__PURE__*/React.createElement("div", {
    className: css.imageShimmer
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), /*#__PURE__*/React.createElement("div", {
    className: css.detailsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: css.priceShimmer
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), /*#__PURE__*/React.createElement("div", {
    className: css.emiShimmer
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), /*#__PURE__*/React.createElement("div", {
    className: css.titleShimmer
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), /*#__PURE__*/React.createElement("div", {
    className: css.detailsShimmer
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), showVasStrip && /*#__PURE__*/React.createElement("div", {
    className: css.stripShimmer,
    "data-aut-id": "vasStripShimmer"
  }, /*#__PURE__*/React.createElement(SkeletonLoader, null))));
};
export default ShimmerCarouselCard;